import styles from './LibraryCard.module.scss';
// import { LibraryCardProps } from './cardData';
//
// type Props = LibraryCardProps & {language: string};

// const LanguageLibraryCard = ({
//   language,
//   displayName,
//   subtitle,
//   content,
//   featuredImage,
// }: Props): JSX.Element => {

const LanguageLibraryCard = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.imgContainer}>
        <div className={styles.wrongGrade}>
          <div className={styles.languageFill}>
            <div className={styles.languageText}>[ES]</div>
            Libros en español disponibles
          </div>
        </div>
      </div>
      <div className={styles.languageTextContainer}>
        <h2 className={styles.languageTitle}>Libros en Español</h2>
        <p>
          ¡Nuestros libros elementales están disponibles en español! Cree o seleccione un salón en español para acceder
          a los libros. <br />
          <br />
          Our elementary books are available in Spanish! Create or select a Spanish-language classroom to access them.
        </p>
        <div className={styles.buttonRow} />
      </div>
    </div>
  );
};

export default LanguageLibraryCard;
